var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('section',{attrs:{"id":_vm.id},on:{"click":_vm.onSelected}},[_c('div',{staticClass:"hardcoded-value"},[_c('mark',[_vm._v(_vm._s(_vm.exp))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }